// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__IuLil","card__title":"styles_card__title__jSGaV","card__image":"styles_card__image__H6rt_"};